// extracted by mini-css-extract-plugin
module.exports = {"searchLoader":"SearchResultView__searchLoader","searchResults":"SearchResultView__searchResults","searchResultsContent":"SearchResultView__searchResultsContent"};